import { render, staticRenderFns } from "./CargoCrudData.vue?vue&type=template&id=52a8e1d8"
import script from "./CargoCrudData.vue?vue&type=script&lang=js"
export * from "./CargoCrudData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports